export default __webpack_public_path__ + "static/media/legal-team-defendant2.7d638883.png";